<div class="flex flex-col gap-4 text-gray-700 text-sm" *vsLet="status$ | async as status">
  <p>
    Connect your Lemur financing account so authorized checkout users can offer Lemur without the API key being exposed
    in the browser. The key is specific to Lemur's Sandbox or Live environment — select the matching environment before
    enabling.
  </p>

  <div *ngIf="blockedReason" class="rounded-lg border border-danger-200 bg-danger-50 px-3 py-2 text-danger-800">
    {{ blockedReason }}
  </div>

  <form [formGroup]="form" class="flex flex-col gap-4">
    <label class="flex flex-col gap-1">
      <span class="text-gray-700 font-medium text-sm">Environment</span>
      <vs-select vsInput formControlName="environment" placeholder="Select environment">
        <li *ngFor="let option of environmentOptions" vs-select-option [value]="option.value">{{ option.label }}</li>
      </vs-select>
      <span class="text-xs text-gray-500">Must match the Sandbox or Live key issued by Lemur.</span>
    </label>

    <label class="flex flex-col gap-1" *ngIf="status?.configured && !editing">
      <span class="text-gray-700 font-medium text-sm">API key</span>
      <input vsInput type="text" readonly [value]="status?.apiKeyDisplay" class="blur-sm hover:blur-none" />
    </label>

    <label class="flex flex-col gap-1" *ngIf="!status?.configured || editing">
      <span class="text-gray-700 font-medium text-sm">API key</span>
      <input
        vsInput
        type="password"
        autocomplete="off"
        placeholder="Enter your Lemur bearer API key"
        formControlName="apiKey"
      />
    </label>
  </form>

  <div class="flex flex-wrap justify-end gap-2" *ngIf="canManageLemur$ | async">
    <button
      *ngIf="status?.configured && !editing"
      vs-button
      type="button"
      appearance="outline"
      [disabled]="saving"
      (click)="startEditing()"
    >
      Edit
    </button>
    <button *ngIf="editing" vs-button type="button" appearance="outline" [disabled]="saving" (click)="cancelEditing()">
      Cancel
    </button>
    <button
      *ngIf="status?.configured"
      vs-button
      type="button"
      appearance="outline"
      theme="danger"
      [disabled]="saving"
      (click)="removeDialog.open()"
    >
      Remove key
    </button>
    <button *ngIf="status?.enabled" vs-button type="button" [disabled]="saving" (click)="disableDialog.open()">
      Disable
    </button>
    <button
      *ngIf="editing"
      vs-button
      type="button"
      theme="primary"
      [disabled]="saving || form.invalid || !!blockedReason"
      (click)="update()"
    >
      {{ saving ? 'Saving...' : 'Update' }}
    </button>
    <button
      *ngIf="!status?.enabled && !editing"
      vs-button
      type="button"
      theme="primary"
      [disabled]="saving || form.invalid || (!status?.configured && !form.controls.apiKey.value) || !!blockedReason"
      (click)="enable()"
    >
      {{ saving ? 'Saving...' : 'Enable' }}
    </button>
  </div>
</div>

<vs-dialog #disableDialog [config]="{dialogContainerClass: 'w-full md:w-96'}">
  <vs-dialog-header
    [config]="{icon: 'bank-note-01', iconTheme:'primary', title: 'Disable Lemur financing?' , subtitle: 'New checkout applications will be blocked. Existing application references and statuses are kept.', mode: 'simple', hideCloseButton: true}"
  ></vs-dialog-header>
  <div class="w-full flex flex-row gap-2 justify-between">
    <button vs-button class="w-1/2" appearance="outline" (click)="disableDialog.close()">Cancel</button>
    <button vs-button class="w-1/2" theme="danger" (click)="disable(); disableDialog.close()">Disable</button>
  </div>
</vs-dialog>

<vs-dialog #removeDialog [config]="{dialogContainerClass: 'w-full md:w-96'}">
  <vs-dialog-header
    [config]="{icon: 'bank-note-01', iconTheme:'primary', title: 'Remove Lemur API key?' , subtitle: 'The key is deleted for this tenant and Lemur financing is disabled. Existing application references are kept.', mode: 'simple', hideCloseButton: true}"
  ></vs-dialog-header>
  <div class="w-full flex flex-row gap-2 justify-between">
    <button vs-button class="w-1/2" appearance="outline" (click)="removeDialog.close()">Cancel</button>
    <button vs-button class="w-1/2" theme="danger" (click)="remove(); removeDialog.close()">Remove key</button>
  </div>
</vs-dialog>
